













































import {
  Vue,
  Component,
} from "@/shared/vuepack";

import { Validator } from "vee-validate";
import DisclosureLinks from "@/employee/components/investments/drivewealth/DisclosureLinks.vue";
import WizardNavigation from "@/employee/components/investments/drivewealth/wizard/WizardNavigation.vue";
import { DrivewealthWizardStep } from "@/shared/types";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { BankCustodian } from "@/admin/types";

@Component ({
  components: {
    DisclosureLinks,
    WizardNavigation,
  }
})
export default class TermsAndConditions extends Vue {
  $validator: Validator;
  drivewealthWizard = useDrivewealthWizardStore();
  custodianSettingsStore = useCustodianSettingsStore();

  tryAdvance () {
    this.$validator
      .validate()
      .then(isValid => {
        if (isValid) {
          this.drivewealthWizard.setWizardStepComplete(DrivewealthWizardStep.TermsAndConditions);
        }
      });
  }

  get didAgreeToTerms () {
    return this.drivewealthWizard.termsDidAgree;
  }

  set didAgreeToTerms (value: boolean) {
    this.drivewealthWizard.setTermsDidAgree(value);
  }

  get wizardStep () {
    return DrivewealthWizardStep.TermsAndConditions;
  }

  get isHsab () {
    return this.custodianSettingsStore.userHsaCustodian === BankCustodian.HsaBank;
  }
}
